import * as Sentry from '@sentry/react';
import {getBrowserInfo} from 'src/shared/utils/browserCompatibility';

/**
 * @registry Identifies the video playback source ('internal' or 'vimeo').
 */
export type VideoProvider = 'internal' | 'vimeo';

/**
 * @registry Builds browser/provider context object attached to video playback error reports.
 */
export function buildVideoErrorContext(provider: VideoProvider, error: unknown) {
  const b = getBrowserInfo();
  return {
    provider,
    browser: b.name,
    browserVersion: b.version,
    isMobile: b.isMobile,
    isEmbedded: b.isEmbedded,
    errorName: (error as {name?: string})?.name ?? 'unknown',
  };
}

/**
 * @registry Reports a video playback error to Sentry with browser/provider tags and context.
 */
export function reportVideoError(provider: VideoProvider, error: unknown): void {
  const ctx = buildVideoErrorContext(provider, error);
  Sentry.withScope(scope => {
    scope.setTags({
      video_provider: ctx.provider,
      browser: ctx.browser,
      is_mobile: ctx.isMobile,
      is_embedded: ctx.isEmbedded,
    });
    scope.setContext('video', ctx);
    Sentry.captureException(
      error instanceof Error ? error : new Error(`video_error:${ctx.provider}`)
    );
  });
}
